






























import Vue from 'vue'
import AppLayout from '@rhitics/vue/components/AppLayout.vue'
import Layout from '@rhitics/vue/components/Layout'

export default Layout.extend({
  name: 'RhiticsLogout',

  components: {
    AppLayout
  },

  data() {
    return {
      isLoading: false
    }
  },

  async created() {
    await this.logout()
  },

  methods: {
    async logout() {

      this.isLoading = true

      try {
        await this.$auth.logout()
      } catch (err: any) {
        console.error(err)
      }

      this.isLoading = false

      this.$bus.$emit('auth-logout')
    }
  }
})
